import { type PropsWithChildren } from 'react';

import { ChartInteractionsConfig } from '../../core/types/interactions.js';
import { HistogramInteractionsContext } from '../contexts/HistogramInteractionsContext.js';

export const HistogramInteractionsProvider = ({
  children,
  config,
}: PropsWithChildren<{ config?: ChartInteractionsConfig }>) => (
  <HistogramInteractionsContext.Provider value={config ?? {}}>
    {children}
  </HistogramInteractionsContext.Provider>
);

HistogramInteractionsProvider['displayName'] = 'HistogramInteractionsProvider';
